import { createFileRoute } from '@tanstack/react-router';
import { LearnArticleDetail } from '~/components/sections/LearnArticleDetail';
import { learnArticleHeadMeta, loadLearnArticle } from '~/lib/learn-article-route';

export const Route = createFileRoute('/article/$slug')({
  loader: ({ params }) => loadLearnArticle('article', params.slug),
  head: ({ loaderData }) => learnArticleHeadMeta(loaderData?.article),
  component: ArticlePage,
});

function ArticlePage() {
  const { article } = Route.useLoaderData();
  return <LearnArticleDetail key={article.fullPath} article={article} />;
}
